import React, { useState, useEffect } from 'react';

const COUNTRIES = [
  'United Kingdom','Ireland','France','Germany','Netherlands','Belgium',
  'Switzerland','Austria','Spain','Italy','Portugal','United States',
  'Canada','Australia','New Zealand','South Africa','UAE','Singapore','Other',
];

const CUISINES = [
  'Fine dining','Casual dining','Café','Bistro','Pub / Bar',
  'Fast casual','Seafood','Steakhouse','Italian','French',
  'Asian','Middle Eastern','Other',
];

const PLATFORMS = [
  'WordPress','Squarespace','Wix','Webflow','Shopify',
  'Custom / Developer-built','Other',"I don't have a website",
];

const REFERRALS = [
  'Instagram','TikTok','Google','Word of mouth','LinkedIn','Other',
];

function InfoTip({ text }) {
  const [show, setShow] = useState(false);
  return (
    <span style={{ position:'relative', display:'inline-flex', alignItems:'center', marginLeft:6, verticalAlign:'middle' }}>
      <span
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        style={{ width:16, height:16, borderRadius:'50%', background:'rgba(99,102,241,.15)',
          border:'1px solid rgba(99,102,241,.3)', color:'#818cf8', fontSize:10, fontWeight:800,
          display:'inline-flex', alignItems:'center', justifyContent:'center',
          cursor:'default', userSelect:'none', flexShrink:0 }}
      >i</span>
      {show && (
        <div style={{ position:'absolute', bottom:'calc(100% + 8px)', left:'50%', transform:'translateX(-50%)',
          background:'#1e293b', color:'#e2e8f0', fontSize:12, lineHeight:1.55, padding:'10px 14px',
          borderRadius:10, width:248, border:'1px solid rgba(255,255,255,.08)', zIndex:300,
          boxShadow:'0 8px 24px rgba(0,0,0,.5)', pointerEvents:'none', textAlign:'left' }}>
          {text}
          <div style={{ position:'absolute', top:'100%', left:'50%', transform:'translateX(-50%)',
            borderLeft:'6px solid transparent', borderRight:'6px solid transparent',
            borderTop:'6px solid #1e293b' }} />
        </div>
      )}
    </span>
  );
}

export default function Apply({ onBack, onSignIn }) {
  const [form, setForm] = useState({
    restaurantName:'', ownerName:'', email:'', phone:'',
    country:'', city:'', plan:'', setupFee: false,
    platform:'', platformOther:'', urlMode:'paste', websiteUrl:'',
    covers:'', cuisine:'', cuisineOther:'', referral:'', referralOther:'',
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading]     = useState(false);
  const [error, setError]         = useState('');

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const noWebsite = form.platform === "I don't have a website";

  useEffect(() => {
    const id = 'seva-apply-styles';
    const existing = document.getElementById(id);
    if (existing) existing.remove();
    const el = document.createElement('style');
    el.id = id;
    el.textContent = `
      .ap-btn-p:hover { transform:translateY(-2px); box-shadow:0 10px 28px rgba(79,70,229,.45)!important; }
      .ap-btn-g:hover { background:rgba(255,255,255,.1)!important; }
      .ap-input:focus { border-color:#6366f1!important; box-shadow:0 0 0 3px rgba(99,102,241,.12)!important; outline:none; }
      .ap-select:focus { border-color:#6366f1!important; box-shadow:0 0 0 3px rgba(99,102,241,.12)!important; outline:none; }
      .ap-plan:hover { border-color:#6366f1!important; }
      .ap-nav-a:hover { color:rgba(255,255,255,.85)!important; }
      .ap-urlpill:hover { border-color:rgba(99,102,241,.5)!important; }
    `;
    document.head.appendChild(el);
    return () => el.remove();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Phone validation
    const cleanPhone = form.phone.replace(/[\s\-().+]/g, '');
    if (!/^\d{7,15}$/.test(cleanPhone)) {
      setError('Please enter a valid phone number (e.g. +44 7700 900000).');
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL || ''}/api/apply`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...form,
          websiteUrl: noWebsite || form.urlMode !== 'paste' ? '' : form.websiteUrl,
        }),
      });
      if (!res.ok) throw new Error('Failed');
      setSubmitted(true);
    } catch (_) {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div style={{ position:'fixed', inset:0, overflowY:'scroll', overflowX:'hidden', zIndex:100 }}>
        <div style={{ fontFamily:'-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif', background:'#0f172a', minHeight:'100vh' }}>
          <Nav onBack={onBack} onSignIn={onSignIn} />
          <div style={{ display:'flex', alignItems:'center', justifyContent:'center', minHeight:'calc(100vh - 64px)',
            padding:'60px 5%', textAlign:'center',
            backgroundImage:'radial-gradient(ellipse 80% 60% at 50% 50%,rgba(79,70,229,.2) 0%,transparent 70%)' }}>
            <div>
              <div style={{ width:72, height:72, borderRadius:'50%', background:'rgba(16,185,129,.15)',
                border:'2px solid rgba(16,185,129,.3)', display:'flex', alignItems:'center',
                justifyContent:'center', margin:'0 auto 28px', fontSize:32 }}>
                ✉️
              </div>
              <h1 style={{ fontSize:'clamp(26px,5vw,44px)', fontWeight:900, color:'#f8fafc',
                letterSpacing:'-1px', margin:'0 0 16px' }}>Check your email</h1>
              <p style={{ fontSize:17, color:'#64748b', lineHeight:1.7, maxWidth:460, margin:'0 auto 12px' }}>
                We've sent a verification link to
              </p>
              <p style={{ fontSize:17, fontWeight:700, color:'#a5b4fc', margin:'0 auto 32px' }}>
                {form.email}
              </p>
              <p style={{ fontSize:14, color:'#475569', lineHeight:1.7, maxWidth:420, margin:'0 auto 16px' }}>
                Click the link in that email to confirm your application. The link expires in 24 hours.
              </p>
              <p style={{ fontSize:13, color:'#334155', background:'rgba(255,255,255,.04)', border:'1px solid rgba(255,255,255,.08)', borderRadius:10, padding:'10px 18px', maxWidth:420, margin:'0 auto 40px', lineHeight:1.6 }}>
                💡 Don't see it? Check your <strong style={{ color:'#a5b4fc' }}>spam or junk folder</strong> — verification emails sometimes land there.
              </p>
              <button onClick={onBack} className="ap-btn-g"
                style={{ background:'rgba(255,255,255,.06)', border:'1px solid rgba(255,255,255,.12)',
                  borderRadius:12, padding:'14px 32px', fontSize:15, fontWeight:600, color:'#e2e8f0',
                  cursor:'pointer', transition:'background .2s' }}>
                ← Back to home
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ position:'fixed', inset:0, overflowY:'scroll', overflowX:'hidden', zIndex:100 }}>
      <div style={{ fontFamily:'-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif', background:'#0f172a', minHeight:'100vh' }}>

        <Nav onBack={onBack} onSignIn={onSignIn} />

        {/* Header */}
        <div style={{ background:'#0f172a',
          backgroundImage:'radial-gradient(ellipse 80% 50% at 50% 0%,rgba(79,70,229,.25) 0%,transparent 65%)',
          padding:'72px 5% 56px', textAlign:'center' }}>
          <div style={{ display:'inline-flex', alignItems:'center', gap:7,
            background:'rgba(79,70,229,.16)', border:'1px solid rgba(99,102,241,.35)',
            borderRadius:24, padding:'5px 14px', marginBottom:24, fontSize:12, fontWeight:700,
            color:'#a5b4fc', letterSpacing:'.06em', textTransform:'uppercase' }}>
            Apply for access
          </div>
          <h1 style={{ fontSize:'clamp(30px,5vw,54px)', fontWeight:900, color:'#f8fafc',
            letterSpacing:'-1.5px', lineHeight:1.1, margin:'0 0 16px' }}>
            Let's get your restaurant set up
          </h1>
          <p style={{ fontSize:18, color:'#64748b', lineHeight:1.7, maxWidth:500, margin:'0 auto' }}>
            Fill in the details below and we'll be in touch to get you onboarded.
          </p>
        </div>

        {/* Form card */}
        <div style={{ maxWidth:680, margin:'0 auto', padding:'0 5% 100px' }}>
          <form onSubmit={handleSubmit}
            style={{ background:'#ffffff', borderRadius:24, padding:'44px 48px',
              border:'1px solid rgba(255,255,255,.08)', boxShadow:'0 40px 80px rgba(0,0,0,.4)' }}>

            {/* ── Restaurant details ── */}
            <SectionLabel>Restaurant details</SectionLabel>

            <Row>
              <Field label="Restaurant name" required>
                <input className="ap-input" required value={form.restaurantName}
                  onChange={e => set('restaurantName', e.target.value)}
                  placeholder="e.g. La Maison" style={inp} />
              </Field>
            </Row>

            <Row two>
              <Field label="Owner name" required>
                <input className="ap-input" required value={form.ownerName}
                  onChange={e => set('ownerName', e.target.value)}
                  placeholder="Full name" style={inp} />
              </Field>
              <Field label="Owner email" required>
                <input className="ap-input" required type="email" value={form.email}
                  onChange={e => set('email', e.target.value)}
                  placeholder="you@restaurant.com" style={inp} />
              </Field>
            </Row>

            <Row two>
              <Field label="Phone number" required>
                <input className="ap-input" required type="tel" value={form.phone}
                  onChange={e => set('phone', e.target.value)}
                  placeholder="+44 7700 900000" style={inp} />
              </Field>
              <Field label="Country" required>
                <select className="ap-select" required value={form.country}
                  onChange={e => set('country', e.target.value)} style={sel}>
                  <option value="">Select country</option>
                  {COUNTRIES.map(c => <option key={c}>{c}</option>)}
                </select>
              </Field>
            </Row>

            <Row two>
              <Field label="City / Town" required>
                <input className="ap-input" required value={form.city}
                  onChange={e => set('city', e.target.value)}
                  placeholder="e.g. London" style={inp} />
              </Field>
              <Field label={
                <span style={{ display:'inline-flex', alignItems:'center' }}>
                  <Opt>Number of covers</Opt>
                  <InfoTip text="The total number of guests your restaurant can seat at one time — i.e. your total seating capacity." />
                </span>
              }>
                <input className="ap-input" type="number" min="1" value={form.covers}
                  onChange={e => set('covers', e.target.value)}
                  placeholder="e.g. 60" style={inp} />
              </Field>
            </Row>

            <Row>
              <Field label={<Opt>Type of cuisine</Opt>}>
                <select className="ap-select" value={form.cuisine}
                  onChange={e => set('cuisine', e.target.value)} style={sel}>
                  <option value="">Select cuisine type</option>
                  {CUISINES.map(c => <option key={c}>{c}</option>)}
                </select>
              </Field>
            </Row>
            {form.cuisine === 'Other' && (
              <Row>
                <Field label="Please specify cuisine">
                  <input className="ap-input" value={form.cuisineOther}
                    onChange={e => set('cuisineOther', e.target.value)}
                    placeholder="e.g. Peruvian" style={inp} autoFocus />
                </Field>
              </Row>
            )}

            {/* ── Website ── */}
            <SectionLabel style={{ marginTop:12 }}>Website</SectionLabel>

            <Row>
              <Field label={
                <span style={{ display:'inline-flex', alignItems:'center' }}>
                  How do you run your website?
                  <InfoTip text="We need to know how your site is built to seamlessly integrate the Seva booking widget — the process varies depending on your platform." />
                </span>
              } required>
                <select className="ap-select" required value={form.platform}
                  onChange={e => { set('platform', e.target.value); if (e.target.value === "I don't have a website") set('urlMode', 'none'); }}
                  style={sel}>
                  <option value="">Select platform</option>
                  {PLATFORMS.map(p => <option key={p}>{p}</option>)}
                </select>
              </Field>
            </Row>

            {form.platform === 'Other' && (
              <Row>
                <Field label="Please specify platform" required>
                  <input className="ap-input" required value={form.platformOther}
                    onChange={e => set('platformOther', e.target.value)}
                    placeholder="e.g. Wix Studio, Ghost…" style={inp} autoFocus />
                </Field>
              </Row>
            )}

            {!noWebsite && form.platform && (
              <Row>
                <Field label={<Opt>Website URL</Opt>}>
                  <div style={{ display:'flex', gap:8, marginBottom:10, flexWrap:'wrap' }}>
                    {[['paste','Paste URL'],['blank','Leave blank'],['none',"No URL yet"]].map(([val, lbl]) => (
                      <button key={val} type="button" className="ap-urlpill"
                        onClick={() => set('urlMode', val)}
                        style={{ padding:'6px 14px', borderRadius:20, fontSize:12, fontWeight:600,
                          cursor:'pointer', transition:'all .15s', border:'1.5px solid',
                          borderColor: form.urlMode === val ? '#6366f1' : '#e2e8f0',
                          background: form.urlMode === val ? 'rgba(99,102,241,.08)' : '#f8fafc',
                          color: form.urlMode === val ? '#4f46e5' : '#64748b' }}>
                        {lbl}
                      </button>
                    ))}
                  </div>
                  {form.urlMode === 'paste' && (
                    <input className="ap-input" type="url" value={form.websiteUrl}
                      onChange={e => set('websiteUrl', e.target.value)}
                      placeholder="https://yourrestaurant.com" style={inp} />
                  )}
                </Field>
              </Row>
            )}

            {/* ── Plan ── */}
            <SectionLabel style={{ marginTop:12 }}>Choose a plan</SectionLabel>

            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14, marginBottom:16 }}>
              <PlanCard
                selected={form.plan === 'core'}
                onClick={() => set('plan', 'core')}
                name="Seva Core"
                price="€75/mo"
                desc="AI booking widget on your existing website"
              />
              <PlanCard
                selected={form.plan === 'launch'}
                onClick={() => set('plan', 'launch')}
                name="Seva Launch"
                price="€75/mo + €99"
                desc="AI booking + professional website built for you"
                popular
              />
            </div>

            {/* Setup fee add-on */}
            <div
              onClick={() => set('setupFee', !form.setupFee)}
              style={{ display:'flex', alignItems:'flex-start', gap:14, padding:'16px 18px',
                borderRadius:14, border:'1.5px solid', cursor:'pointer', marginBottom:24,
                borderColor: form.setupFee ? '#6366f1' : '#e2e8f0',
                background: form.setupFee ? 'rgba(99,102,241,.05)' : '#fafafa',
                transition:'all .15s' }}>
              <div style={{ width:20, height:20, borderRadius:6, border:'1.5px solid', flexShrink:0, marginTop:1,
                borderColor: form.setupFee ? '#4f46e5' : '#cbd5e1',
                background: form.setupFee ? '#4f46e5' : 'transparent',
                display:'flex', alignItems:'center', justifyContent:'center', transition:'all .15s' }}>
                {form.setupFee && (
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                )}
              </div>
              <div>
                <div style={{ fontSize:14, fontWeight:700, color: form.setupFee ? '#4338ca' : '#1e293b', marginBottom:3 }}>
                  Add professional onboarding setup
                  <span style={{ marginLeft:8, fontSize:11, fontWeight:600, color:'#10b981',
                    background:'rgba(16,185,129,.1)', borderRadius:6, padding:'2px 8px' }}>Optional</span>
                </div>
                <div style={{ fontSize:13, color:'#64748b', lineHeight:1.5 }}>
                  Our team configures your tables, floor plan, hours & AI — pricing tailored to your venue. We'll quote you after reviewing your application.
                </div>
              </div>
            </div>

            {/* ── How did you hear ── */}
            <Row>
              <Field label={<Opt>How did you hear about Seva?</Opt>}>
                <select className="ap-select" value={form.referral}
                  onChange={e => set('referral', e.target.value)} style={sel}>
                  <option value="">Select…</option>
                  {REFERRALS.map(r => <option key={r}>{r}</option>)}
                </select>
              </Field>
            </Row>
            {form.referral === 'Other' && (
              <Row>
                <Field label="Please specify">
                  <input className="ap-input" value={form.referralOther}
                    onChange={e => set('referralOther', e.target.value)}
                    placeholder="Tell us how you found us" style={inp} autoFocus />
                </Field>
              </Row>
            )}

            {error && (
              <div style={{ background:'#fef2f2', color:'#dc2626', border:'1px solid #fecaca',
                borderRadius:10, padding:'10px 14px', fontSize:13, marginBottom:16 }}>
                {error}
              </div>
            )}

            <button type="submit"
              disabled={loading || !form.plan}
              className="ap-btn-p"
              style={{ width:'100%', marginTop:8, background: !form.plan ? '#c7d2fe' : '#4f46e5',
                border:'none', borderRadius:12, padding:'15px', fontSize:15, fontWeight:700,
                color:'#fff', cursor: !form.plan ? 'not-allowed' : 'pointer',
                transition:'transform .2s,box-shadow .2s',
                boxShadow:'0 2px 16px rgba(79,70,229,.3)' }}>
              {loading ? 'Submitting…' : 'Submit application →'}
            </button>

            <p style={{ textAlign:'center', fontSize:12, color:'#94a3b8', marginTop:16, lineHeight:1.6 }}>
              You'll receive a verification email to confirm your address. No payment is taken at this stage.
            </p>
          </form>
        </div>

        {/* Footer */}
        <footer style={{ background:'#060a12', borderTop:'1px solid rgba(255,255,255,.04)',
          padding:'28px 5%', display:'flex', alignItems:'center',
          justifyContent:'space-between', flexWrap:'wrap', gap:12 }}>
          <div style={{ display:'flex', alignItems:'center', gap:8 }}>
            <div style={{ width:26, height:26, borderRadius:7, overflow:'hidden', flexShrink:0 }}>
              <img src="/icon-192.png" alt="Seva" style={{ width:'100%', height:'100%', objectFit:'cover' }} />
            </div>
            <span style={{ fontSize:14, fontWeight:700, color:'#334155' }}>Seva</span>
          </div>
          <div style={{ fontSize:13, color:'#1e293b' }}>© 2025 Seva. All rights reserved.</div>
        </footer>
      </div>
    </div>
  );
}

/* ── Nav ── */
function Nav({ onBack, onSignIn }) {
  return (
    <nav style={{ position:'sticky', top:0, zIndex:200, height:64, padding:'0 5%',
      display:'flex', alignItems:'center', justifyContent:'space-between',
      background:'rgba(15,23,42,0.9)', backdropFilter:'blur(16px)',
      WebkitBackdropFilter:'blur(16px)', borderBottom:'1px solid rgba(255,255,255,.06)' }}>
      <div style={{ display:'flex', alignItems:'center', gap:10 }}>
        <div style={{ width:34, height:34, borderRadius:9, overflow:'hidden', flexShrink:0 }}>
          <img src="/icon-192.png" alt="Seva" style={{ width:'100%', height:'100%', objectFit:'cover' }} />
        </div>
        <span style={{ fontSize:18, fontWeight:800, color:'#f1f5f9', letterSpacing:'-0.3px' }}>Seva</span>
      </div>
      <div style={{ display:'flex', alignItems:'center', gap:8 }}>
        <button onClick={onBack} className="ap-btn-g"
          style={{ background:'rgba(255,255,255,.06)', border:'1px solid rgba(255,255,255,.1)',
            borderRadius:8, padding:'7px 16px', color:'rgba(255,255,255,.6)', fontSize:14,
            fontWeight:500, cursor:'pointer', transition:'background .15s', display:'flex',
            alignItems:'center', gap:6 }}>
          ← Back
        </button>
        <button onClick={onSignIn} className="ap-btn-g"
          style={{ background:'rgba(255,255,255,.06)', border:'1px solid rgba(255,255,255,.1)',
            borderRadius:8, padding:'7px 16px', color:'#e2e8f0', fontSize:14,
            fontWeight:600, cursor:'pointer', transition:'background .15s' }}>
          Sign in
        </button>
      </div>
    </nav>
  );
}

/* ── Plan card ── */
function PlanCard({ selected, onClick, name, price, desc, popular }) {
  return (
    <div onClick={onClick} className="ap-plan"
      style={{ borderRadius:16, padding:'20px 20px', cursor:'pointer', transition:'all .18s',
        border: selected ? '2px solid #6366f1' : '2px solid #e2e8f0',
        background: selected ? 'rgba(99,102,241,.06)' : '#fafafa',
        position:'relative' }}>
      {popular && (
        <div style={{ position:'absolute', top:12, right:12, background:'#4f46e5',
          borderRadius:20, padding:'2px 10px', fontSize:10, fontWeight:700, color:'#fff' }}>
          Popular
        </div>
      )}
      <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:8 }}>
        <div style={{ width:18, height:18, borderRadius:'50%', border:'2px solid',
          borderColor: selected ? '#6366f1' : '#cbd5e1',
          background: selected ? '#6366f1' : 'transparent',
          display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, transition:'all .15s' }}>
          {selected && <div style={{ width:7, height:7, borderRadius:'50%', background:'#fff' }} />}
        </div>
        <span style={{ fontSize:14, fontWeight:700, color: selected ? '#4338ca' : '#1e293b' }}>{name}</span>
      </div>
      <div style={{ fontSize:16, fontWeight:900, color: selected ? '#4338ca' : '#0f172a', marginBottom:4 }}>{price}</div>
      <div style={{ fontSize:12, color:'#64748b', lineHeight:1.5 }}>{desc}</div>
    </div>
  );
}

/* ── Helpers ── */
function Opt({ children }) {
  return <>{children} <span style={{ color:'#94a3b8', fontWeight:500, fontSize:10, textTransform:'none', letterSpacing:0 }}>(optional)</span></>;
}
function SectionLabel({ children, style }) {
  return (
    <div style={{ fontSize:11, fontWeight:700, color:'#94a3b8', textTransform:'uppercase',
      letterSpacing:'.08em', marginBottom:16, marginTop:8, ...style }}>
      {children}
    </div>
  );
}
function Row({ children, two }) {
  return (
    <div style={{ display: two ? 'grid' : 'block', gridTemplateColumns: two ? '1fr 1fr' : undefined, gap: two ? 16 : undefined }}>
      {children}
    </div>
  );
}
function Field({ label, required, children }) {
  return (
    <div style={{ marginBottom:18 }}>
      <label style={{ display:'block', fontSize:11, fontWeight:700, color:'#64748b',
        marginBottom:7, textTransform:'uppercase', letterSpacing:'.06em' }}>
        {label}{required && <span style={{ color:'#ef4444', marginLeft:3 }}>*</span>}
      </label>
      {children}
    </div>
  );
}

const inp = {
  width:'100%', background:'#f8fafc', border:'1.5px solid #e2e8f0', borderRadius:10,
  padding:'11px 14px', fontSize:14, color:'#0f172a', outline:'none',
  boxSizing:'border-box', transition:'border-color .18s, box-shadow .18s', fontFamily:'inherit',
};
const sel = {
  ...inp, appearance:'none', WebkitAppearance:'none',
  backgroundImage:`url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2.5'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E")`,
  backgroundRepeat:'no-repeat', backgroundPosition:'right 12px center', paddingRight:36,
};
